<template>
  <Modal v-model="modal" :title="data.Number" :mask-closable="false">
    <Row type="flex" justify="center" align="middle">
      <Col span="4" class="label">{{$t('label.w3')}}</Col>
      <Col span="8">
        <span class="b">{{(data.Rate*100).toFixed(1)}}</span>
        <span
          v-if="data.AddRate||userRate"
          class="amount"
        >+{{((data.AddRate+userRate)*100).toFixed(1)}}</span> %
      </Col>
      <Col span="4">{{$t('label.w80')}}</Col>
      <Col span="8">
        <span class="b">{{data.LoanCycleValue<30?data.LoanCycleValue:data.LoanCycleValue/30}}</span>
        {{data.LoanCycleValue<30?$t('label.w15'):$t('label.w14')}}
      </Col>
    </Row>
    <Row type="flex" justify="center" align="middle" :style="{margin:'15px 0'}">
      <Col span="4" class="label">{{$t('label.w103')}}</Col>
      <Col span="10">
        <Select :disabled="!user.InvestReturnList" v-model="coupon">
          <!-- <Option value="" v-if="!user.InvestReturnList||user.InvestReturnList.length<1">{{$t('option.w36')}}</Option> -->
          <Option value>{{$t('option.w72')}}</Option>
          <Option
            v-for="v in user.InvestReturnList"
            :key="v.Id"
            :value="v.Id"
          >{{$t('option.w59').replace('{%}',(v.Rate*100).toFixed(1))}}</Option>
        </Select>
      </Col>
      <Col span="10">
        <span v-show="backamount" :style="{marginLeft:'20px'}">
          {{$t('label.w206')}}
          <span class="text-warning">{{backamount}}</span>
          {{$t('label.w5')}}
        </span>
      </Col>
    </Row>
    <Row type="flex" justify="center" align="middle">
      <Col span="4" class="label">{{$t('label.w1')}}</Col>
      <Col span="8">
        <span class="amount">{{amount | money}}</span>
        {{$t('label.w5')}}
      </Col>
      <Col span="4">{{$t('label.w229')}}</Col>
      <Col span="8">
        <span class="amount">{{ income | money}}</span>
        {{$t('label.w5')}}
      </Col>
    </Row>
    <Row type="flex" justify="center" align="middle">
      <Col span="4" class="label">{{$t('label.w234')}}</Col>
      <Col span="8">
        <span>{{ lixi | money}}</span>
        {{$t('label.w5')}}
      </Col>
      <Col span="4">{{$t('other.w135')}}</Col>
      <Col span="8">
        <span>{{guan | money}}</span>
        {{$t('label.w5')}}
      </Col>
    </Row>
    <template slot="footer">
      <Button
        type="primary"
        :loading="loading"
        :disabled="!amount"
        @click="submit"
      >{{$t('btn.b38')}}</Button>
    </template>
  </Modal>
</template>
<script>
import comp from "@/libs/comp";
export default {
  props: ["data", "user", "fees", "days"],
  data() {
    return {
      modal: false,
      amount: 0,
      coupon: "",
      loading: false,
      backamount: 0,
    };
  },
  computed: {
    //预计收益
    income() {
      return this.lixi - this.guan;
    },
    //管理费
    guan() {
      if (this.data.LoanType == "1") {
        return 0;
      } else {
        return this.amount * this.fees * this.days;
      }
    },
    // 每期利息
    lixi() {
      return (
        ((this.amount * (this.data.AddRate + this.data.Rate)) / 12) *
        (this.data.LoanCycleValue / 30)
      );
    },

    inv() {
      return comp.interest(
        this.amount,
        this.data.Rate + this.data.AddRate + this.userRate,
        this.data.LoanCycleValue
      );
    },
    // 期数
    stag() {
      return comp.stag(this.data.LoanCycleValue);
    },
    // 优惠券利率
    userRate() {
      if (!this.user.InvestReturnList || !this.user.InvestReturnList.length)
        return 0;
      let active = this.user.InvestReturnList.filter(
        (v) => v.Id == this.coupon
      )[0];
      if (!active) return 0;
      return active.Rate;
    },
  },
  watch: {
    modal(v) {
      if (!v) return;
      this.getbackamount();
    },
  },
  methods: {
    async submit() {
      this.loading = true;
      let res = await this.$axios.post("/Member/RZJLoan/Invest", {
        loanSchemeId: this.data.Id,
        investReturnId: this.coupon,
        amount: this.amount,
      });
      this.loading = false;
      res.throw();
      if (!res.err) {
        this.$router.push({ name: "investOrder" });
      }
    },
    async getbackamount() {
      let res = await this.$axios.get("/Member/RZJLoan/InvestRedbagAmount", {
        params: { amount: this.amount },
      });
      if (res.err) return res.throw();
      this.backamount = res;
    },
  },
};
</script>
<style lang="less" scoped>
.b {
  color: #232325;
  font-size: 38px;
}
.amount {
  color: #ff6106;
  font-size: 24px;
}
.label {
  color: #232325;
}
</style>
